import z from "zod";

export const ProjectFeatureSchemas = {
  create: z.object({ featureId: z.uuidv7(), projectId: z.uuidv7() }),

  delete: z.object({ featureId: z.uuidv7(), projectId: z.uuidv7() }),

  export: z.object({ featureId: z.uuidv7(), projectId: z.uuidv7() }).array(),
};
